var map = {
	"./fish1.png": "aHgi",
	"./fish10.png": "PZNB",
	"./fish100.png": "I+1t",
	"./fish11.png": "6sNh",
	"./fish12.png": "+obr",
	"./fish13.png": "IS9c",
	"./fish14.png": "iUeh",
	"./fish15.png": "sADf",
	"./fish16.png": "ow82",
	"./fish17.png": "zhIs",
	"./fish18.png": "qXmb",
	"./fish19.png": "z1v3",
	"./fish2.png": "BsP/",
	"./fish20.png": "piFb",
	"./fish22.png": "wZFR",
	"./fish23.png": "jLm4",
	"./fish24.png": "5A0n",
	"./fish25.png": "3X0e",
	"./fish26.png": "hJGH",
	"./fish3.png": "MIqG",
	"./fish4.png": "SSwE",
	"./fish5.png": "dGsM",
	"./fish50.png": "Mp/D",
	"./fish51.png": "NnGz",
	"./fish52.png": "l8nQ",
	"./fish53.png": "BH2R",
	"./fish54.png": "XRlC",
	"./fish55.png": "wOVB",
	"./fish6.png": "tIqR",
	"./fish7.png": "RzZi",
	"./fish8.png": "Rndn",
	"./fish9.png": "V5NG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "BuTt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jingdianfish ^\.\/fish.*\.png$
// module id = BuTt
// module chunks = 0